export default __webpack_public_path__ + "static/media/playIcon.897d38e1.svg";